export const COMMON_CONST = {
  WIDGET_TYPE_ADD: 'WIDGET_TYPE_ADD',
};

// Application constnats
export const PRIMARY_COLOR = '#9871EA';
export const DEFAULT_WIDGET_COLOR = '#C2BAF2';
